export default {
  setAdminEmail(state, val) {
    state.adminEmail = val
  },
  setFireBaseAuthError(state, val) {
    state.fireBaseAuthError = val
  },
  setIsAdmin(state, val) {
    state.isAdmin = val
  },
  setPerformingRequest(state, val) {
    state.performingRequest = val
  },
  setUserProfile(state, val) {
    state.userProfile = val
  },
  setPackages(state, val) {
    state.packages = val
  },
  setQueriedUserProfile(state, val) {
    state.queriedUserProfile = val
  },
  setQueriedUserTimelineStep(state, val) {
    state.queriedUserProfile.timelineStep = val
  },
  setUserTimelineStep(state, val) {
    state.userProfile.timelineStep = val
  }
}